"use client";

import {
  toSnakeCase
} from "./chunk-ZNPQQ2WK.mjs";

// src/libraries/react/client/clientReferralMethods.ts
async function createCode(params) {
  let snakeParams = toSnakeCase(params);
  const res = await this.post("/api/autumn/referrals/code", snakeParams);
  return res;
}
async function redeemCode(params) {
  let snakeParams = toSnakeCase(params);
  const res = await this.post("/api/autumn/referrals/redeem", snakeParams);
  return res;
}

export {
  createCode,
  redeemCode
};
